import { AREA } from '../types/appSchema';
export default () => {
  return window.localStorage.getItem('managementArea') || AREA.SOUTHERN;
};
